define('root/app_store/Podio.UI.AppStore.InstallShare',['require','translate','underscore','jquery','lib/jquery/jquery.podioDropdown','lib/Podio.Routes','lib/Podio.UI.CreateSpaceModal','lib/Podio.Router','lib/Podio.UI.Modal','lib/Podio.Transport','lib/Podio.Event.UI'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.podioDropdown');

  var routes = require('lib/Podio.Routes');

  var shareId = null;
  var shareName = '';
  var shareDependencies = [];

  var createSpaceModal = require('lib/Podio.UI.CreateSpaceModal');
  var router = require('lib/Podio.Router');
  var modal = require('lib/Podio.UI.Modal');
  var transport = require('lib/Podio.Transport');
  var eventUI = require('lib/Podio.Event.UI');

  function showDependencies() {
    modal.showLoading(t('Install share #store.install_share'));

    var req = transport.getJSON(routes.install_share_dependencies_share_path(shareId), {});

    req.done(function(responseData) {
      if (responseData.status === 'ok') {
        shareName = responseData.data.name;
        if (responseData.data.has_dependencies) {
          modal.show(responseData.data.html, {
            title: responseData.data.title,
            footerHtml: responseData.data.footer
          });
        } else {
          shareDependencies = [];
          showSelectSpace();
        }
      }
    });
  }

  function onDependencyClicked(elmTarget, e) {
    elmTarget.toggleClass('selected');
  }

  function onGetSelectedClicked(elmTarget, e) {
    shareDependencies = _.collect($('#install_share_dependencies ul.dependencies-list li.selected'), function(node) { return $(node).data('id'); });
    showSelectSpace();
  }

  function onGetOnlyParentClicked(elmTarget, e) {
    showSelectSpace();
  }

  function showSelectSpace() {
    modal.showLoading(t('Install share #store.install_share'));

    var req = transport.getJSON(routes.install_share_select_space_share_path(shareId), {});

    req.done(function(responseData) {
      modal.show(responseData.data.html, {
        title: responseData.data.title,
        footerHtml: responseData.data.footer
      });
      initSelectSpace();
    });
  }

  function initSelectSpace() {
    var elmSpaceDropdown = $('#install_share_select_space #dropdown_space_id');
    var elmSpaceOptions = elmSpaceDropdown.find('option');
    if (elmSpaceOptions.length) {
      elmSpaceDropdown.podioDropdown();
    } else {
      // No spaces to install to, render create space instead
      showCreateSpace();
    }
  }

  function onCreateSpaceClicked(elmTarget, e) {
    showCreateSpace();
  }

  function showCreateSpace() {
    createSpaceModal.show({title: t('Install share #store.install_share'), newUrl: routes.new_space_path({'privacy':'closed', 'name': shareName, 'show_existing_space_link': true}), callback: function(space) {
      installShareToSelectedSpace(space.id);
    }});
  }

  function onSubmitSelectedSpaceClicked(elmTarget, e) {
    var elmSpaceDropdown = $('#install_share_select_space #dropdown_space_id');
    installShareToSelectedSpace(elmSpaceDropdown.val());
  }

  function installShareToSelectedSpace(spaceId) {
    modal.showLoading(t('Installing share #store.install_share'));

    var req = transport.postJSON(routes.install_share_install_share_path(shareId), {
      requestData: {
        space_id: spaceId,
        dependencies: shareDependencies
      }
    });

    req.done(function(responseData) {
      if (responseData.status === 'ok') {
        modal.show(responseData.data.html, {
          title: responseData.data.title,
          footerHtml: responseData.data.footer
        });
      }
    });

  }

  function onShowExistingSpaceClicked(elmTarget, e) {
    showSelectSpace();
  }

  function onInstallShareRouteInvoked(routeData) {
    shareId = routeData.params[0];
    showDependencies();
    router.goToHashRoute(''); // Clear hash straight away
  }

  router.addHashRoute('shares/{share_id}/install', onInstallShareRouteInvoked);

  eventUI.bind('click', '#install_share_dependencies ul.dependencies-list li', onDependencyClicked);
  eventUI.bind('click', '.modal-footer .try-all', onGetSelectedClicked);
  eventUI.bind('click', '.modal-footer .try-single', onGetOnlyParentClicked);
  eventUI.bind('click', '#install_share_select_space .create-space', onCreateSpaceClicked);
  eventUI.bind('click', '.submit-selected-space-button', onSubmitSelectedSpaceClicked);
  eventUI.bind('click', '.modal-content .show-existing-space', onShowExistingSpaceClicked);

});

